module.exports = __webpack_public_path__ + "static/media/NewRole.fd75e599.svg";